module.exports = __webpack_public_path__ + "static/media/ship-streak-1.fb618368.jpg";